import React from "react";
import "./css/scheduleText.css";

function ScheduleText() {
  return (
    <div className="scheduleText" id="scheduleSection1">
      <h1>Our Class Schedule</h1>
      <div>
        <strong>
          <p>CFBJJ Main Location</p>
        </strong>
        <p>1420 Gemini Blvd, Orlando, FL 32837</p>
      </div>
    </div>
  );
}

export default ScheduleText;
